<template>
  <div>
    <div v-if="loading" class="text-center mb-4">
      <i class="fa fa-spinner fa-spin fa-2x"></i>
    </div>

    <div v-else class="address">
      <!--show searchBar-->
      <!--searchBar: v-auto-complete component-->
      <div v-if="showSearchBar" class="row" style="margin-bottom: 15px;">
        <div class="address-search col-sm-24">
          <v-autocomplete
            :items="items"
            v-model="item"
            :get-label="getLabel"
            :min-len="0"
            :component-item="template"
            @update-items="update"
            @item-selected="itemSelected"
            @item-clicked="itemClicked"
            @focus="inputFocus"
            @blur="inputBlur"
            @button-clicked="buttonClicked"
            :auto-select-one-item="false"
            :input-attrs="{
              name: 'input-test',
              id: 'v-my-autocomplete',
              class: 'form-control'
            }"
            :placeholder="'Search your saved ' + type + ' locations...'"
            :isloading="isloading"
            :focusSearch="focusSearch"
            @open-form="onOpenForm"
          >
          </v-autocomplete>
        </div>
      </div>
      <!--show location item-->
      <div v-if="showSearchBar" class="address-dropdown">
        <!--empty box-->
        <div
          v-if="Object.keys(selected).length === 0"
          @click="clickEmptyLocation($event)"
          style="height: 95px;border: 1px dashed #B9BED1;background-color:#f8f9fa;cursor: pointer;display: flex;align-content: center;"
        >
          <p style="margin: auto;color: #B9BED1;font-size: 16px;">
            No {{ type }} location has been chosen
          </p>
        </div>
        <!--show location details box-->
        <location-selector-item
          v-else
          @clickItem="clickEmptyLocation($event)"
          @showForm="showLocationForm(selected)"
          :location="selected"
          style="border: 1px solid #28A745;box-shadow: 0 2px 4px 0 rgba(0,0,0,0.17);box-sizing: border-box;margin: -1px;"
        ></location-selector-item>
      </div>

      <!--do not show searchBar-->
      <div v-if="!showSearchBar">
        <div
          class="address-dropdown"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <button
            v-if="Object.keys(selected).length === 0"
            class="address-item text-muted"
            style="min-height: 96px;"
          >
            Select your {{ type }} location
          </button>
          <location-selector-item
            v-else
            @showForm="onOpenForm(selected)"
            :location="selected"
          ></location-selector-item>
        </div>
        <div class="dropdown-menu address-menu btn-block" style="z-index: 100">
          <div class="options-holder">
            <div
              v-bind:class="[location.id === selected.id ? 'selected' : null]"
              v-for="(location, index) in locations"
            >
              <location-selector-item
                @showForm="onOpenForm(location)"
                @click.native="updateSelected(location, $event)"
                :location="location"
                :dropdownItem="true"
              ></location-selector-item>
              <div
                v-if="index < locations.length - 1"
                class="dropdown-divider"
              ></div>
            </div>
          </div>
          <div class="text-center">
            <div class="dropdown-divider" style="margin-top: 0"></div>
            <button type="button" class="btn-link" @click="buttonClicked">
              <i class="far fa-plus-circle"></i>
              Add New Location
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Autocomplete from "./v-autocomplete/Autocomplete.vue";
import LocationSelectorItem from "./LocationSelectorItem.vue";
import LocationItem from "./LocationItem.vue";

export default {
  name: "location-selector",
  components: {
    "v-autocomplete": Autocomplete,
    LocationSelectorItem,
    LocationItem
  },
  props: ["locations", "selected", "loading", "type"],
  data: function() {
    return {
      itemsApi: [],
      item: null,
      items: [],
      template: LocationItem,
      isloading: false,
      focusSearch: false,
      showSearchBar: true
    };
  },
  methods: {
    updateSelected(location, event) {
      if (event) event.preventDefault();
      Event.$emit(this.type + "LocationChanged", location);
    },
    showNewLocationForm() {
      // console.log("add");
      this.$emit("showForm", { type: this.type });
    },
    showLocationForm(location) {
      // console.log("edit", location);
      this.$emit("showForm", { type: this.type, location: location });
    },
    itemSelected(item) {
      // console.log("Selected an item!", item);
      this.updateSelected(item);
      this.item = null;
    },
    itemClicked(item) {
      // console.log("You clicked an item!", item);
      item.prompted = true;
      if (item.ownershipStatus !== "OWNED_BY_ANOTHER") {
        if (item.contact_name === null || item.phone === null) {
          this.$swal({
            title:
              "Please provide contact name and phone number at your location",
            type: "warning"
          }).then(() => this.showLocationForm(item));
        }
      }
    },
    buttonClicked() {
      this.showNewLocationForm();
    },
    getLabel(item = null) {
      // console.log('getLabel');
      if (item) {
        return item.name;
      }
      return "";
    },
    update(text) {
      // console.log("update: sending a request to the server");
      this.isloading = true;
      axios
        .get("/settings/locations/" + this.type + "/queryByName?q=" + encodeURIComponent(text))
        .then(response => {
          // console.log("got result from server", response);
          this.items = response.data.data;
          this.isloading = false;
        })
        .catch(this.showServerError);
    },
    inputFocus(text) {
      console.log("Focus");
    },
    inputBlur(text) {
      console.log("Blur");
      this.focusSearch = false;
    },
    clickEmptyLocation(event) {
      console.log("click the empty box");
      this.focusSearch = true;
    },
    onOpenForm(location) {
      this.showLocationForm(location);
    }
  },
  watch: {
    locations: function(val) {
      if (val.length < 6) {
        this.showSearchBar = false;
      }
      this.items = val;
    }
  }
};
</script>

<style lang="stylus">
.v-autocomplete
  .v-autocomplete-input-group
    input
      border-radius 0.25em
      cursor  text
    &.v-autocomplete-selected
      .v-autocomplete-input
        color green
        background-color #f2fff2
  .v-autocomplete-dropdown
    width 100%
    background-color #fff
    z-index 99
    border-radius: 0.3em
    border 1px solid #ccc
    .v-autocomplete-loading
      border-bottom 1px solid #ccc
    .v-autocomplete-list
        width 100%
        text-align left
        max-height 350px
        overflow-y auto
        .v-autocomplete-list-item
            cursor pointer
            background-color #fff
            border-bottom 1px solid #e9ecef
            &:last-child
              border-bottom none
            &:hover
              background-color #eee
            abbr
              opacity 0.8
              font-size 0.8em
              display block
              font-family sans-serif
    .v-autocomplete-button
      height 45px
    .v-autocomplete-noresult
      height 45px
      display table
      width 100%
      .v-autocomplete-noresult-text
        display table-cell
        text-align center
        vertical-align middle

pre
  text-align left
  white-space pre-wrap
  background-color #eee
  border 1px solid silver
  padding 20px !important
  border-radius 10px
  font-family monospace !important
.left
  text-align left
.note
  border-left 5px solid #ccc
  padding 10px
</style>
